import SEO from '@/components/shared/SEO'
import Reviews from '@/components/Reviews'
import KeyInformation from '@/components/KeyInformation'
import USPBanner from '@/components/USPBanner'
import ClaimProcessSteps from '@/components/shared/ClaimProcessSteps'
import VehicleHeroSection from '@/components/shared/VehicleHeroSection'
import VehicleClaimExplanation from '@/components/shared/VehicleClaimExplanation'
import VehicleFactsSection from '@/components/shared/VehicleFactsSection'
import VehicleClaimSteps from '@/components/shared/VehicleClaimSteps'
import VehicleLinksSection from '@/components/shared/VehicleLinksSection'
import LenderLinksSection from '@/components/shared/LenderLinksSection'
import FAQ from '@/components/FAQ'
import { useFaqs } from '@/hooks/useFaqs'

const VehicleMakeLandingPageTemplate = ({
  vehicleMake,
  slug,
  seoImage = '',
  seoImageAlt = '',
}) => {
  const { faqs } = useFaqs(5)

  // Determine correct article (a/an) based on vehicle make
  const getArticle = name => {
    const vowelSounds = ['A', 'E', 'I', 'O', 'U']
    return vowelSounds.includes(name.charAt(0).toUpperCase()) ? 'an' : 'a'
  }

  const article = getArticle(vehicleMake)
  const heroImage = seoImage || '/Image/Car-photo-illustration-claims1.webp'

  return (
    <div className="flex-1">
      <SEO
        title={`${vehicleMake} Car Finance Claims - Check Eligibility in 60 Seconds | Your Claim Matters`}
        description={`Were you mis-sold ${vehicleMake} car finance between 2007-2021? You could be owed compensation. Check your eligibility for free in just 60 seconds.`}
        keywords={`${vehicleMake} car finance claims, ${vehicleMake} PCP claims, ${vehicleMake} HP claims, ${vehicleMake} finance compensation, mis-sold ${vehicleMake} finance`}
        url={slug}
        image={heroImage}
        imageAlt={seoImageAlt || `${vehicleMake} car finance claims`}
        schemaType="WebPage"
        schemaData={{
          mainEntity: {
            '@type': 'Service',
            name: `${vehicleMake} Car Finance Claim Service`,
            description: `Professional car finance mis-selling claims service for ${vehicleMake} vehicle owners`,
            provider: {
              '@type': 'Organization',
              name: 'Your Claim Matters',
              url: 'https://yourclaimmatters.co.uk',
            },
            areaServed: 'United Kingdom',
            serviceType: 'Legal Services',
          },
        }}
        breadcrumbs={[
          { name: 'Home', url: '/' },
          { name: 'Vehicle Makes', url: '/vehicles' },
          { name: `${vehicleMake} Claims`, url: slug },
        ]}
      />

      <USPBanner />

      {/* Hero Section */}
      <VehicleHeroSection vehicleMake={vehicleMake} heroImage={heroImage} />

      {/* Body Section */}
      <VehicleClaimExplanation vehicleMake={vehicleMake} article={article} />

      {/* Facts Section */}
      <VehicleFactsSection vehicleMake={vehicleMake} article={article} />

      {/* Process Section */}
      <VehicleClaimSteps vehicleMake={vehicleMake} />

      {/* Claim Process Steps Section */}
      <ClaimProcessSteps lenderName={vehicleMake} />

      {/* Vehicle Makes Section */}
      <VehicleLinksSection currentVehicle={vehicleMake} />

      {/* Lender Links Section */}
      <LenderLinksSection />

      {/* Reviews Section */}
      <Reviews />

      {/* FAQ Section */}
      <FAQ faqs={faqs} includeStructuredData={false} />

      {/* Key Facts Section */}
      <KeyInformation />
    </div>
  )
}

export default VehicleMakeLandingPageTemplate
